import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/icons/users-remove.tsx
function r({ colors: r, style: i, ...a }) {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(r),
			...i
		},
		...a,
		children: [
			/* @__PURE__ */ t("path", {
				d: "M16 21C16 20.0547 15.999 19.3957 15.9639 18.8799C15.9293 18.373 15.8648 18.0769 15.7715 17.8516C15.467 17.1168 14.8832 16.533 14.1484 16.2285C13.9231 16.1352 13.627 16.0707 13.1201 16.0361C12.6043 16.001 11.9453 16 11 16H8C7.05468 16 6.39572 16.001 5.87988 16.0361C5.37297 16.0707 5.07695 16.1352 4.85156 16.2285C4.11679 16.533 3.53299 17.1168 3.22852 17.8516C3.13516 18.0769 3.07072 18.373 3.03613 18.8799C3.00096 19.3957 3 20.0547 3 21C3 21.5523 2.55229 22 2 22C1.44772 22 1 21.5523 1 21C1 20.0818 0.999119 19.3429 1.04004 18.7432C1.08157 18.1345 1.16981 17.5965 1.38086 17.0869C1.88833 15.8618 2.86178 14.8883 4.08692 14.3809C4.59653 14.1698 5.13455 14.0816 5.74317 14.04C6.34293 13.9991 7.0818 14 8 14H11C11.9182 14 12.6571 13.9991 13.2568 14.04C13.8655 14.0816 14.4035 14.1698 14.9131 14.3809C16.1382 14.8883 17.1117 15.8618 17.6191 17.0869C17.8302 17.5965 17.9184 18.1345 17.96 18.7432C18.0009 19.3429 18 20.0818 18 21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21ZM21 21V19C21 17.6908 20.1605 16.5758 18.9893 16.167L18.751 16.0947L18.6533 16.0645C18.1776 15.8893 17.9023 15.3784 18.0313 14.877C18.1689 14.3422 18.7143 14.0198 19.249 14.1572C21.4053 14.7122 23 16.6688 23 19V21C23 21.5523 22.5523 22 22 22C21.4477 22 21 21.5523 21 21ZM12.5 7C12.5 5.34315 11.1569 4 9.5 4C7.84315 4 6.5 5.34315 6.5 7C6.5 8.65685 7.84315 10 9.5 10C11.1569 10 12.5 8.65685 12.5 7ZM17 7C17 5.82109 16.3197 4.79904 15.3272 4.30859L15.125 4.21777L15.0322 4.1748C14.5839 3.93828 14.3792 3.39598 14.5732 2.91602C14.7805 2.40409 15.3631 2.15706 15.875 2.36426C17.7056 3.10525 19 4.90006 19 7C19 9.09994 17.7056 10.8948 15.875 11.6357C15.3631 11.8429 14.7805 11.5959 14.5732 11.084C14.3663 10.5721 14.6132 9.98941 15.125 9.78223C16.2262 9.33639 17 8.25736 17 7ZM14.5 7C14.5 9.76142 12.2614 12 9.5 12C6.73858 12 4.5 9.76142 4.5 7C4.5 4.23858 6.73858 2 9.5 2C12.2614 2 14.5 4.23858 14.5 7Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ n("g", {
				clipPath: "url(#clip0_15682_30461)",
				children: [/* @__PURE__ */ t("path", {
					d: "M18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23Z",
					fill: "var(--icon-color-on, var(--color-icon-on, white))"
				}), /* @__PURE__ */ t("path", {
					d: "M16 18H20M23 18C23 20.7614 20.7614 23 18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18Z",
					stroke: "var(--icon-color-primary, currentColor)",
					strokeWidth: "1.5",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", {
				id: "clip0_15682_30461",
				children: /* @__PURE__ */ t("rect", {
					width: "12",
					height: "12",
					fill: "var(--icon-color-primary, currentColor)",
					transform: "translate(12 12)"
				})
			}) })
		]
	});
}
//#endregion
export { r as UsersRemoveIcon };
